// pages/Contact/Contact.jsx - Fully branded DevLearn Contact page
import { ArrowRight, MapPin, Phone, Mail, MessageCircle, Send } from 'lucide-react';
import { useState } from 'react';
import '../../index.css';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', type: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Form submitted:', formData);
  //   setSubmitted(true);
  //   setTimeout(() => setSubmitted(false), 5000);
  // };


  const handleSubmit = async (e) => {
  e.preventDefault();

  const formUrl = 
    'https://docs.google.com/forms/d/e/1FAIpQLSczGY0Fn2vWhCre5zXxBZjnDbP62d2mD_V9kr1mW26uVBb9BQ/formResponse';

  const formBody = new URLSearchParams({
    'entry.1845496574': formData.name,
    'entry.316619462': formData.email,
    'entry.1329809532': formData.type,        // now sends the full correct string
    'entry.1941210778': formData.message,
  });

  try {
    await fetch(formUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formBody,
    });

    // We assume success (no-cors hides real status)
    setSubmitted(true);
    setFormData({ name: '', email: '', type: '', message: '' });
    setTimeout(() => setSubmitted(false), 5000);
  } catch (error) {
    console.error('Form submission error:', error);
    // Optional: show error to user
    alert('There was a problem sending the message. Please try again.');
  }
};
//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   const formUrl =
//     'https://docs.google.com/forms/d/e/1FAIpQLSczGY0Fn2vWhCre5zXxBZjnDbP62d2mD_V9kr1mW26uVBb9BQ/formResponse';

//   const formBody = new URLSearchParams({
//     'entry.1845496574': formData.name,
//     'entry.316619462': formData.email,
//     'entry.1329809532': formData.type,
//     'entry.1941210778': formData.message,
//     submit: 'Submit',
//   });

//   await fetch(formUrl, {
//     method: 'POST',
//     mode: 'no-cors',
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded',
//     },
//     body: formBody.toString(),
//   });

//   setSubmitted(true);
//   setFormData({ name: '', email: '', type: '', message: '' });
//   setTimeout(() => setSubmitted(false), 5000);
// };


//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   const formUrl =
//     //'https://docs.google.com/forms/d/e/FORM_ID_HERE/formResponse';
//     'https://docs.google.com/forms/d/e/1FAIpQLSczGY0Fn2vWhCre5zXxBZjnDbP62d2mD_V9kr1mW26uVBb9BQ/formResponse';

//   const formBody = new URLSearchParams({
//     'entry.1845496574': formData.name,
//     'entry.316619462': formData.email,
//     'entry.1329809532': formData.type,
//     'entry.1941210778': formData.message,
//   });

//   try {
//     // await fetch(formUrl, {
//     //   method: 'POST',
//     //   mode: 'no-cors',
//     //   body: formBody,
//     // });
//     await fetch(formUrl, {
//       method: 'POST',
//       mode: 'no-cors',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       body: formBody,
//     });


//     setSubmitted(true);

//     // optional: clear form
//     setFormData({
//       name: '',
//       email: '',
//       type: '',
//       message: '',
//     });

//     setTimeout(() => setSubmitted(false), 5000);
//   } catch (error) {
//     console.error('Submission error:', error);
//   }
// };


  const accentOrange = '#F7941D';
  const accentYellow = '#FBB040';
  const accentPink = '#BA477C';
  const mainFont = "'Poppins', sans-serif";

  return (
    <>
      {/* Hero */}
      <section className="hero" style={{ background: 'linear-gradient(180deg, #F0F9FF 0%, #ffffff 100%)', fontFamily: mainFont }}>
        <div className="container">
          <h1 style={{ color: accentPink, fontWeight: 700 }}>Get In Touch</h1>
          <p style={{ fontWeight: 400 }}>
            Whether you're exploring partnerships, seeking MERL expertise, or starting a project, our team is here to collaborate. Let's measure what matters together.
          </p>
          <div className="hero-buttons">
            <a href="#form" className="btn btn-primary" style={{ background: accentOrange, color: '#fff', fontWeight: 600 }}>
              Start a Conversation <ArrowRight />
            </a>
            <a href="#contacts" className="btn btn-secondary" style={{ background: accentPink, color: '#fff', fontWeight: 600 }}>
              Our Contacts
            </a>
          </div>
        </div>
      </section>

      {/* Contacts Section */}
      <section id="contacts" className="section contacts" style={{ fontFamily: mainFont }}>
        <div className="container">
          <div className="text-center">
            <h2 style={{ color: accentPink, fontWeight: 700 }}>Reach Out Directly</h2>
            <p className="lead" style={{ fontWeight: 400 }}>
              Connect with us via email, phone, or social media. We're based in Lusaka, Zambia, with a global network.
            </p>
          </div>
          <div className="contacts-grid">
            {[
              { icon: <Mail size={32} />, title: 'Email Us', detail: 'info@devlearnimpact.com', link: 'mailto:info@devlearnimpact.com', linkText: 'Send a Message' },
              { icon: <Phone size={32} />, title: 'Call Us', detail: '+260 973 902 981 / +260 978 341 825', link: 'tel:+260973902981', linkText: 'Make a Call' },
              { icon: <MapPin size={32} />, title: 'Visit Us', detail: 'Plot No. 3788/A, Avondale Road, Lusaka, Zambia', link: 'https://maps.google.com/?q=Plot+No.+3788/A,+Avondale+Road,+Lusaka', linkText: 'View on Map' },
              { icon: <MessageCircle size={32} />, title: 'Follow Us', detail: 'Stay updated on our latest research and insights', social: [{ name: 'LinkedIn', link: 'https://www.linkedin.com/company/devlearn-impact-research/' }, { name: 'Facebook', link: 'https://www.facebook.com/share/1AS3Ahfsy7/' }] }
            ].map((item, idx) => (
              <div key={idx} className="contact-item">
                <div className="contact-icon">{item.icon}</div>
                <h3 style={{ color: accentPink, fontWeight: 700 }}>{item.title}</h3>
                <p>{item.detail}</p>
                {item.link ? (
                  <a href={item.link} className="contact-link" style={{ color: accentOrange, fontWeight: 600 }}>{item.linkText}</a>
                ) : (
                  <div className="social-links">
                    {item.social.map((s, i) => (
                      <a key={i} href={s.link} target="_blank" rel="noopener noreferrer" style={{ color: accentPink, marginRight: '15px', fontWeight: 600 }}
                        onMouseEnter={e => e.currentTarget.style.color = accentYellow}
                        onMouseLeave={e => e.currentTarget.style.color = accentPink}>
                        {s.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section id="form" className="section form-section bg-light" style={{ background: '#F0F9FF', fontFamily: mainFont }}>
        <div className="container">
          <div className="text-center">
            <h2 style={{ color: accentPink, fontWeight: 700 }}>Start Your Project</h2>
            <p className="lead" style={{ fontWeight: 400 }}>
              Fill out the form to discuss your MERL needs, research ideas, or partnership opportunities. We'll respond within 24 hours.
            </p>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group"><input type="text" name="name" placeholder="Your Full Name" value={formData.name} onChange={handleChange} required style={{ fontFamily: mainFont }} /></div>
            <div className="form-group"><input type="email" name="email" placeholder="Your Email Address" value={formData.email} onChange={handleChange} required style={{ fontFamily: mainFont }} /></div>
            {/* <div className="form-group">
              <select name="type" value={formData.type} onChange={handleChange} required style={{ fontFamily: mainFont }}>
                <option value="">What best describes your inquiry?</option>
                <option value="project">Start a New Project</option>
                <option value="info">Request More Information</option>
                <option value="partnership">Explore Partnership</option>
                <option value="other">Something Else</option>
              </select>
            </div> */}
            <div className="form-group">
              <select 
                name="type" 
                value={formData.type} 
                onChange={handleChange} 
                required 
                style={{ fontFamily: mainFont }}
              >
                <option value="">What best describes your inquiry?</option>
                <option value="Start a New Project">Start a New Project</option>
                <option value="Request More Information">Request More Information</option>
                <option value="Explore Partnership">Explore Partnership</option>
                <option value="Something Else">Something Else</option>
              </select>
            </div>
            <div className="form-group"><textarea name="message" placeholder="Tell us about your project or question..." rows="6" value={formData.message} onChange={handleChange} required style={{ fontFamily: mainFont }}></textarea></div>
            <button type="submit" className="btn btn-primary form-submit" style={{ background: accentOrange, color: '#fff', fontWeight: 700 }}>
              {submitted ? 'Sending...' : 'Send Message'} <Send size={20} />
            </button>
            {submitted && <p className="success-msg" style={{ color: accentPink, fontWeight: 600 }}>Thanks! We'll get back to you soon.</p>}
          </form>
        </div>
      </section>

      {/* CTA */}
      <section className="final-cta text-center" style={{ background: accentPink, color: '#fff', padding: '80px 20px', fontFamily: mainFont }}>
        <div className="container">
          <h2 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '25px', lineHeight: '1.3' }}>
            Join DevLearn in Empowering Change.<br />Let's Collaborate on Evidence-Led Solutions.
          </h2>
          <a href="/team" className="btn btn-primary" style={{ background: accentOrange, color: '#fff', padding: '12px 28px', borderRadius: '8px', fontWeight: 700, fontSize: '1rem' }}>
            Meet Our Team <ArrowRight size={28} />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" style={{ background: '#111827', color: '#9CA3AF', padding: '60px 20px', fontFamily: mainFont }}>
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '30px', marginBottom: '30px' }}>
          <div>
            <div className="footer-logo" style={{ color: accentPink, fontWeight: 700, fontSize: '1.25rem', marginBottom: '15px' }}>DevLearn Impact Research Ltd</div>
            <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
            <p>+260 973 902 981 / +260 978 341 825</p>
            <p>info@devlearnimpact.com</p>
          </div>
          <div>
            <h4 style={{ color: '#fff', fontWeight: 600, marginBottom: '12px' }}>Services</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="/services" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Applied Research</a></li>
              <li><a href="/services" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>MERL Frameworks</a></li>
              <li><a href="/services" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Capacity Building</a></li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#fff', fontWeight: 600, marginBottom: '12px' }}>Thematic Areas</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="/sectors" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Education & Health</a></li>
              <li><a href="/sectors" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Governance & Climate</a></li>
              <li><a href="/sectors" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Economic Inclusion</a></li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#fff', fontWeight: 600, marginBottom: '12px' }}>Company</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="/about" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>About</a></li>
              <li><a href="/team" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Team</a></li>
              <li><a href="/case-studies" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Projects</a></li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#fff', fontWeight: 600, marginBottom: '12px' }}>Connect</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="https://www.linkedin.com/company/devlearn-impact-research/" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/" style={{ color: '#9CA3AF', textDecoration: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = accentOrange} onMouseLeave={e => e.currentTarget.style.color = '#9CA3AF'}>Facebook</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright" style={{ textAlign: 'center', color: '#6B7280', fontSize: '0.9rem' }}>
          © 2026 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
        </div>
      </footer>
    </>
  );
};

export default Contact;


// // pages/Contact/Contact.jsx - Contact Us page for DevLearn
// import { ArrowRight, MapPin, Phone, Mail, MessageCircle, Send } from 'lucide-react';
// import { useState } from 'react';
// import '../../index.css'; // Shared global styles
// import './Contact.css'; // Page-specific styles

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     type: '',
//     message: ''
//   });
//   const [submitted, setSubmitted] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Placeholder for form submission (e.g., integrate EmailJS or API)
//     console.log('Form submitted:', formData);
//     setSubmitted(true);
//     setTimeout(() => setSubmitted(false), 5000);
//   };

//   return (
//     <>
//       {/* Hero */}
//       <section className="hero" style={{ background: 'linear-gradient(180deg, #F0F9FF 0%, #ffffff 100%)' }}>
//         <div className="container">
//           <h1 style={{ color: '#1E3A8A' }}>Get In Touch</h1>
//           <p>
//             Whether you're exploring partnerships, seeking MERL expertise, or starting a project, our team is here to collaborate. Let's measure what matters together.
//           </p>
//           <div className="hero-buttons">
//             <a href="#form" className="btn btn-primary">
//               Start a Conversation <ArrowRight />
//             </a>
//             <a href="#contacts" className="btn btn-secondary">
//               Our Contacts
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Contacts Section */}
//       <section id="contacts" className="section contacts">
//         <div className="container">
//           <div className="text-center">
//             <h2 style={{ color: '#1E3A8A' }}>Reach Out Directly</h2>
//             <p className="lead">
//               Connect with us via email, phone, or social media. We're based in Lusaka, Zambia, with a global network.
//             </p>
//           </div>
//           <div className="contacts-grid">
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <Mail size={32} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Email Us</h3>
//               <p>info@devlearnimpact.com</p>
//               <a href="mailto:info@devlearnimpact.com" className="contact-link">Send a Message</a>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <Phone size={32} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Call Us</h3>
//               <p>+260 973 902 981 / +260 978 341 825</p>
//               <a href="tel:+260973902981" className="contact-link">Make a Call</a>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <MapPin size={32} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Visit Us</h3>
//               <p>Plot No. 3788/A, Avondale Road, Lusaka, Zambia</p>
//               <a href="https://maps.google.com/?q=Plot+No.+3788/A,+Avondale+Road,+Lusaka" className="contact-link" target="_blank" rel="noopener noreferrer">View on Map</a>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <MessageCircle size={32} />
//               </div>
//               <h3 style={{ color: '#1E3A8A' }}>Follow Us</h3>
//               <p>Stay updated on our latest research and insights</p>
//               <div className="social-links">
//                 <a href="https://www.linkedin.com/company/devlearn-impact-research/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
//                 <a href="https://www.facebook.com/share/1AS3Ahfsy7/" target="_blank" rel="noopener noreferrer">Facebook</a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Form Section */}
//       <section id="form" className="section form-section bg-light" style={{ background: '#F0F9FF' }}>
//         <div className="container">
//           <div className="text-center">
//             <h2 style={{ color: '#1E3A8A' }}>Start Your Project</h2>
//             <p className="lead">
//               Fill out the form to discuss your MERL needs, research ideas, or partnership opportunities. We'll respond within 24 hours.
//             </p>
//           </div>
//           <form className="contact-form" onSubmit={handleSubmit}>
//             <div className="form-group">
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Your Full Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Your Email Address"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <select name="type" value={formData.type} onChange={handleChange} required>
//                 <option value="">What best describes your inquiry?</option>
//                 <option value="project">Start a New Project</option>
//                 <option value="info">Request More Information</option>
//                 <option value="partnership">Explore Partnership</option>
//                 <option value="other">Something Else</option>
//               </select>
//             </div>
//             <div className="form-group">
//               <textarea
//                 name="message"
//                 placeholder="Tell us about your project or question..."
//                 rows="6"
//                 value={formData.message}
//                 onChange={handleChange}
//                 required
//               ></textarea>
//             </div>
//             <button type="submit" className="btn btn-primary form-submit">
//               {submitted ? 'Sending...' : 'Send Message'} <Send size={20} />
//             </button>
//             {submitted && <p className="success-msg">Thanks! We'll get back to you soon.</p>}
//           </form>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="final-cta text-center" style={{ background: '#1E3A8A', color: '#fff' }}>
//         <div className="container">
//           <h2>
//             Join DevLearn in Empowering Change.<br />Let's Collaborate on Evidence-Led Solutions.
//           </h2>
//           <a href="/team" className="btn btn-primary" style={{ background: '#fff', color: '#1E3A8A' }}>
//             Meet Our Team <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer - Reused with DevLearn details */}
//       <footer className="footer" style={{ background: '#111827' }}>
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo" style={{ color: '#0D9488' }}>DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright" style={{ color: '#9CA3AF' }}>
//           © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Contact;

// // pages/Contact/Contact.jsx - Contact Us page
// import { ArrowRight, MapPin, Phone, Mail, MessageCircle, Send } from 'lucide-react';
// import { useState } from 'react';
// import '../../index.css'; // Shared global styles
// import './Contact.css'; // Page-specific styles

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     type: '',
//     message: ''
//   });
//   const [submitted, setSubmitted] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Placeholder for form submission (e.g., integrate EmailJS or API)
//     console.log('Form submitted:', formData);
//     setSubmitted(true);
//     // Reset form after a delay if needed
//     setTimeout(() => setSubmitted(false), 5000);
//   };

//   return (
//     <>
//       {/* Hero */}
//       <section className="hero">
//         <div className="container">
//           <h1>Get In Touch</h1>
//           <p>
//             Whether you're ready to start a project, explore our services, or just have a question,
//             we're here to help. Let's turn your ideas into impactful research.
//           </p>
//           <div className="hero-buttons">
//             <a href="#form" className="btn btn-primary">
//               Start a Conversation <ArrowRight />
//             </a>
//             <a href="#contacts" className="btn btn-secondary">
//               Our Contacts
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Contacts Section */}
//       <section id="contacts" className="section contacts">
//         <div className="container">
//           <div className="text-center">
//             <h2>Reach Out Directly</h2>
//             <p className="lead">
//               Connect with us via email, phone, or visit our offices. We're global, but always local.
//             </p>
//           </div>
//           <div className="contacts-grid">
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <Mail size={32} />
//               </div>
//               <h3>Email Us</h3>
//               <p>hello@DevLearnresearch.com</p>
//               <a href="mailto:hello@DevLearnresearch.com" className="contact-link">Send a Message</a>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <Phone size={32} />
//               </div>
//               <h3>Call Us</h3>
//               <p>+1 (555) 123-4567</p>
//               <a href="tel:+15551234567" className="contact-link">Make a Call</a>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <MapPin size={32} />
//               </div>
//               <h3>Visit Us</h3>
//               <p>123 DevLearn Ave, Nairobi, Kenya<br />Global offices in London & New York</p>
//               <a href="#" className="contact-link">View on Map</a>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">
//                 <MessageCircle size={32} />
//               </div>
//               <h3>Follow Us</h3>
//               <p>Stay updated on research trends and DevLearns</p>
//               <div className="social-links">
//                 <a href="#" aria-label="LinkedIn">LinkedIn</a>
//                 <a href="#" aria-label="Twitter">Twitter</a>
//                 <a href="#" aria-label="Newsletter">Newsletter</a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Form Section */}
//       <section id="form" className="section form-section bg-light">
//         <div className="container">
//           <div className="text-center">
//             <h2>Start Your Project</h2>
//             <p className="lead">
//               Fill out the form below to discuss your research needs. We'll respond within 24 hours.
//             </p>
//           </div>
//           <form className="contact-form" onSubmit={handleSubmit}>
//             <div className="form-group">
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Your Full Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Your Email Address"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <select name="type" value={formData.type} onChange={handleChange} required>
//                 <option value="">What best describes your inquiry?</option>
//                 <option value="project">Start a New Project</option>
//                 <option value="info">Request More Information</option>
//                 <option value="partnership">Explore Partnership</option>
//                 <option value="other">Something Else</option>
//               </select>
//             </div>
//             <div className="form-group">
//               <textarea
//                 name="message"
//                 placeholder="Tell us about your project or question..."
//                 rows="6"
//                 value={formData.message}
//                 onChange={handleChange}
//                 required
//               ></textarea>
//             </div>
//             <button type="submit" className="btn btn-primary form-submit">
//               {submitted ? 'Sending...' : 'Send Message'} <Send size={20} />
//             </button>
//             {submitted && <p className="success-msg">Thanks! We'll get back to you soon.</p>}
//           </form>
//         </div>
//       </section>

//       {/* Footer - Reused for consistency */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">DevLearn Research</div>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Market Research</a></li>
//               <li><a href="/services">Impact Evaluation</a></li>
//               <li><a href="/services">Data Analytics</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Sectors</h4>
//             <ul>
//               <li><a href="/sectors">Education</a></li>
//               <li><a href="/sectors">Public Health</a></li>
//               <li><a href="/sectors">Finance & Development</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="#">Team</a></li>
//               <li><a href="#">Reports</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Contact</h4>
//             <ul>
//               <li><a href="/contact">hello@DevLearnresearch.com</a></li>
//               <li><a href="/contact">Locations</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2025 DevLearn Research. All rights reserved.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Contact;